<template>
  <div>
    <div>
      <div
        v-for="group of selectedCampaign.fields"
        :key="group.id"
        class="flex flex-wrap py-2 w-full"
      >
        <button
          class="flex items-stretch w-96 text-left rounded shadow focus:outline-none"
          @click="selectGroup(group)"
        >
          <div
            class="flex flex-shrink-0 justify-center items-center w-16 rounded-l"
            :style="{ backgroundColor: group.color }"
          />
          <div class="flex flex-1 justify-between items-center bg-white hover:bg-gray-100 rounded-r border-t border-r border-b">
            <div class="flex-1 py-3 px-4">
              <span class="font-medium text-gray-900" v-text="group.title" />
            </div>
          </div>
        </button>
        <div class="flex sm:block justify-around py-1 sm:pl-5 mt-2 sm:mt-0 sm:space-y-1 w-full sm:w-auto">
          <p class="text-sm"><span class="font-medium" v-text="formatNum(group.count)" /> <span class="text-gray-500">{{ $tc('field', group.count) }}</span></p>
          <p class="text-sm"><span class="font-medium" v-text="formatNum(group.area)" /> <span class="text-gray-500">Ar</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatNum } from '@/helpers'

  export default {
    name: 'GroupSelection',
    props: {
      selectedCampaign: { type: Object, required: true }
    },
    emits: ['select'],
    methods: {
      formatNum,
      selectGroup (group) {
        this.$emit('select', { groupID: group.id })
      }
    }
  }
</script>
